module.exports = __webpack_public_path__ + "img/reading-guy.ec3db7ba.png";